module.exports = __webpack_public_path__ + "img/sc.466ea693.svg";